// extracted by mini-css-extract-plugin
export default {"inputNumber":"VendorOrderRequest_inputNumber__p2zQa"};